import { render, staticRenderFns } from "./ContestImportsTable.vue?vue&type=template&id=3a1c412c&scoped=true&"
import script from "./ContestImportsTable.vue?vue&type=script&lang=js&"
export * from "./ContestImportsTable.vue?vue&type=script&lang=js&"
import style0 from "./ContestImportsTable.vue?vue&type=style&index=0&id=3a1c412c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a1c412c",
  null
  
)

export default component.exports